export default __webpack_public_path__ + "static/media/bolt.189f2660.svg";